<nz-modal [(nzVisible)]="visible" [nzTitle]="'Recurring Transactions'" [nzWidth]="'700px'" [nzFooter]="null"
          (nzOnCancel)="closeModal()">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="form" nzLayout="vertical">
      <nz-row nzGutter="16">
        <!-- Template Name -->
        <nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label [nzFor]="'templateName'" nzRequired>Template Name</nz-form-label>
            <nz-form-control [nzErrorTip]="templateNameError">
              <input nz-input formControlName="templateName" />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <ng-template #templateNameError>
          <ng-container *ngIf="form.controls['templateName'].hasError('required')">
            Template Name is required.
          </ng-container>
          <ng-container *ngIf="form.controls['templateName'].hasError('maxlength')">
            Template Name cannot exceed 100 characters.
          </ng-container>
        </ng-template>
        <!-- Document Type -->
        <nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label [nzFor]="'docType'" nzRequired>Document Type</nz-form-label>
            <nz-form-control nzErrorTip="Document Type is required">
              <nz-select [nzDisabled]="true" formControlName="docType"
                         (ngModelChange)="handleDocTypeChange($event)">
                <nz-option *ngFor="let doc of documentTypes" [nzValue]="doc.value"
                           [nzLabel]="doc.label"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>


        <!-- Recurrence Type -->
        <nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label [nzFor]="'recurrenceType'" nzRequired>
              Recurrence Type
              <span style="margin-left: 5px;" nz-icon nzType="question-circle" nzTheme="outline"
                    [nz-tooltip]="recurrenceTypeTooltip"></span>
            </nz-form-label>
            <nz-form-control nzErrorTip="Recurrence Type is required">
              <nz-select formControlName="recurrenceType"
                         (ngModelChange)="handleRecurrenceTypeChange($event)">
                <nz-option *ngFor="let type of recurrenceTypes" [nzValue]="type.value"
                           [nzLabel]="type.label"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <ng-template #recurrenceTypeTooltip>
          Decide if transactions recur on a schedule, as needed, or with reminders.
        </ng-template>
        <!-- Interval -->
        <nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label [nzFor]="'interval'" nzRequired>Interval</nz-form-label>
            <nz-form-control nzErrorTip="Interval is required">
              <nz-select formControlName="interval" (ngModelChange)="handleIntervalChange($event)"
                         [nzDisabled]="form.get('recurrenceType')?.value === 1">
                <nz-option *ngFor="let interval of intervals" [nzValue]="interval.value"
                           [nzLabel]="interval.label"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <!-- Start Date -->
        <nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label [nzFor]="'startDate'">Start Date</nz-form-label>
            <nz-form-control>
              <nz-date-picker formControlName="startDate"
                              [nzDisabled]="form.get('recurrenceType')?.value === 1"
                              [nzFormat]="dateFormatService.currentDateFormatValue"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <!-- End Date -->
        <nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label [nzFor]="'expiryDate'">End Date</nz-form-label>
            <nz-form-control>
              <nz-date-picker formControlName="expiryDate"
                              [nzDisabled]="form.get('recurrenceType')?.value === 1"
                              [nzFormat]="dateFormatService.currentDateFormatValue"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <!-- Every -->
        <nz-col nzSpan="8" *ngIf="showEveryField">
          <nz-form-item>
            <nz-form-label [nzFor]="'every'" nzRequired>Every</nz-form-label>
            <nz-form-control>
              <nz-select formControlName="every"
                         [nzDisabled]="form.get('recurrenceType')?.value === 1 || !showEveryField">
                <nz-option *ngFor="let option of everyOptions" [nzValue]="option.value"
                           [nzLabel]="option.label"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <!-- Next Run Date -->
        <nz-col nzSpan="8" *ngIf="showNextRunDate">
          <nz-form-item>
            <nz-form-label [nzFor]="'nextRunDate'">Next Run Date</nz-form-label>
            <nz-form-control>
              <nz-date-picker formControlName="nextRunDate"
                              [nzDisabled]="form.get('recurrenceType')?.value === 1"
                              [nzDisabledDate]="disablePastDates"
                              [nzFormat]="dateFormatService.currentDateFormatValue"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <!-- Create Transaction in Advance -->
        <nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label [nzFor]="'createTransactionInAdvance'">Create transaction in
              advance
            </nz-form-label>
            <nz-form-control>
              <input nz-input type="number" formControlName="createTransactionInAdvance" />
              <span class="text-gray">days before</span>
            </nz-form-control>
          </nz-form-item>
        </nz-col>

        <!-- Days to Remind -->
        <nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label [nzFor]="'daysToRemind'"
                           [nzRequired]="form.get('recurrenceType')?.value === 2">No. of days to remind before the next
              run
            </nz-form-label>
            <nz-form-control [nzErrorTip]="getDaysToRemindErrorMessage()">
              <input nz-input type="number" formControlName="daysToRemind" />
            </nz-form-control>
          </nz-form-item>
        </nz-col>

      </nz-row>

      <!-- Footer Buttons -->
      <nz-row nzJustify="space-between" class="mt-md">
        <nz-col>
          <!-- Active Switch -->
          <label>
            <nz-switch formControlName="active"></nz-switch>
            <span class="ml-sm">Active</span>
          </label>
        </nz-col>
        <nz-col>
          <!-- Cancel Button -->
          <button type="button" nz-button nzType="default" (click)="closeModal()">Cancel</button>
          <!-- Save Button -->
          <button type="button" nz-button nzType="primary" [nzLoading]="loading" [disabled]="form.invalid || loading"
                  (click)="saveTransaction()">
            Save Template
          </button>
        </nz-col>
      </nz-row>

    </form>
  </ng-container>
</nz-modal>
